import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import HSCodeEditForm from '~/containers/hsCodeEdit/hsCodeEdit';
import HSCodeArchive from '~/containers/hsCodeArchive/hsCodeArchive';

export class HSCodeEditPage extends Component {
  state = {
    hsCode: null
  };

  onReceiveHSCode = ({ hsCode }) => {
    this.setState({
      hsCode
    });
  };

  render() {
    const hsCodeId = this.props.match.params.hsCodeId;
    const { hsCode } = this.state;

    const editButton = (
      <div className="flex">
        <HSCodeArchive className="mr4" code={hsCode} />
        <Link to={`/settings/hscodes/${hsCodeId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back={`/settings/hscodes/${hsCodeId}`}
          backText="HSCode"
          title={hsCode ? hsCode.name : '...'}
          button={editButton}
        />
        <HSCodeEditForm onCompleted={this.onReceiveHSCode} id={hsCodeId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(HSCodeEditPage));



// WEBPACK FOOTER //
// ./src/pages/hsCodeEdit/hsCodeEdit.jsx